import React from 'react'

import LoadingScreen from '../LoadingScreenComponent'
import formatPrice from '../../utils/formatPrice'
import dayjs from 'dayjs'

import Api from '../../services/ApiService'

export default class StepFourComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            status: 'confirming',
            confirmationChecks: 0,
            loadingScreen: {
                isLoading: true,
                text: 'Ordren behandles...'
            }
        }

        this.checkOrderConfirmation = this.checkOrderConfirmation.bind(this)
    }

    componentDidMount() {
        this.checkOrderConfirmation()
    }

    checkOrderConfirmation() {
        let order_id = this.props.order.order.orderid

        Api.orderStatus(order_id)
            .then(response => {
                if (response.status === 'confirmed') {
                    this.setState({
                        status: response.status,
                        loadingScreen: {
                            isLoading: false,
                            text: 'Færdig...'
                        }
                    })
                } else {
                    this.setState(({confirmationChecks}) => (
                        {
                            confirmationChecks: confirmationChecks + 1
                        }
                    ))

                    if (this.state.confirmationChecks > 5) {
                        this.setState({
                            loadingScreen: {
                                isLoading: false
                            },
                            status: 'timeout'
                        })
                    } else {
                        setTimeout(() => {
                            this.checkOrderConfirmation()
                        }, 5000)
                    }
                }
            })
    }

    render () {
        let { customer, order, card, startDate, room } = this.props.order
        let { loadingScreen, status } = this.state

        if (loadingScreen.isLoading) {
            return <LoadingScreen text={loadingScreen.text} height="300" />
        } else if (status === 'timeout') {
            return (
                <div style={{
                    fontFamily: 'Montserrat, sans-serif',
                    color: '#F06F2F',
                    fontWeight: 700,
                    textAlign: 'center',
                    marginBottom: 10
                }}>
                    <p>
                        Du vil modtage en ordrebekræftelse snarest pr. mail.
                    </p>
                </div>
            )
        } else {
            return (
                <div>
                    <span
                        style={{
                            fontFamily: 'Montserrat, sans-serif',
                            color: '#F06F2F',
                            fontWeight: 700,
                            textAlign: 'center',
                            marginBottom: 10
                        }}
                    >
                        Ordrebekræftelse
                    </span>
                    <div>
                        <div
                            style={{
                                fontFamily: 'Montserrat, sans-serif'
                            }}
                        >
                            <p>
                                Din bestilling er nu gennemført, du vil modtage
                                en email snarest.
                            </p>
                            <p>
                                <b>Navn</b>: {customer.name}
                            </p>
                            <p>
                                <b>Email</b>: {customer.email}
                            </p>
                            <p>
                                <b>Dato</b>: {dayjs(order.date).format('DD/MM/YYYY')}
                            </p>
                            <p>
                                <b>Transaktions ID</b>: {order.txnid}
                            </p>
                            <p>
                                <b>Ordre ID</b>: {order.orderid}
                            </p>
                            <p>
                                <b>Beløb</b>: {formatPrice(order.amount)} DKK
                            </p>
                            <p>
                                <b>Kort</b>: {card.displayname}
                            </p>
                            <p>
                                <b>Depotrum</b>: {room.size} m<sup>3</sup>,{' '}
                                {room.place}, indflytning d.{' '}
                                {startDate.format('DD/MM/YYYY')}
                            </p>
                        </div>
                    </div>
                </div>
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/steps/StepFourComponent.jsx